import { TooltipTypes } from '../../../utils/tooltipConstants';
import generateRender from '../../../utils/generateRender';
import { isTablet, isAndroid, isMobile } from 'react-device-detect';
export var piggyBankTooltipDetail = function piggyBankTooltipDetail(_ref) {
  var title = _ref.title;
  var targetElement = document.getElementById('piggy-bank-icon');
  if (!targetElement) return null;
  var rect = targetElement.getBoundingClientRect();
  var x_pos = rect.left + rect.width / 2;
  var y_pos = rect.bottom + 6;
  var tooltipWidth = 300;
  var adjustedX = Math.min(Math.max(x_pos - tooltipWidth / 2, 10), window.innerWidth - tooltipWidth - 10);
  var detail = {
    popUpType: TooltipTypes.MISSIONS,
    animationState: 'AnimationSlideFromTop',
    title: title,
    titleStyle: piggyTooltipTextStyle,
    style: {
      zIndex: 1000,
      left: adjustedX,
      top: y_pos,
      width: tooltipWidth
    }
  };
  return detail;
};
var piggyTooltipTextStyle = generateRender({
  default: {
    fontSize: '1.4rem',
    paddingTop: 19,
    lineHeight: '1.6rem',
    minHeight: '5.5rem'
  },
  sga: {
    fontSize: '1.4rem',
    paddingTop: isTablet ? isAndroid ? 19 : 24 : isMobile && !isAndroid ? 23 : 19,
    lineHeight: '1.6rem',
    minHeight: '5.5rem'
  }
});